export default class LoginParam {
  public email: string = ''
  public password: string = ''

  public constructor(fields?: {
    email?: string,
    password?: string,
  }) {
    if (fields) {
      Object.assign(this, fields)
    }
  }
}
